/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

// import parse from "html-react-parser";

import "../../css/event220902.css";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
import { isMobile } from "react-device-detect";
import $ from "jquery";
import ReactPlayer from "react-player";

class Event202209_liveShopping extends Component {
  state = {
    play: false,
    mHeight: 367,
    videoUrl: "",
  };
  componentDidMount = () => {
    //this._getWindowSize()
    this._getUrl();
  };

  _getUrl = async () => {
    const result = await this._getUrlApi();
    const intReturn = result.data[0].intReturn;
    const urlData = result.data[0].listData;

    if (intReturn === 0) {
      const pos = urlData[0].url.lastIndexOf("/");
      const chat = urlData[0].url.substr(pos + 1, urlData[0].url.length);
      //console.log(chat)

      this.setState({
        videoUrl: urlData[0].url,
        chatUrl: chat,
        gubun: urlData[0].gubun,
      });
    }
  };
  _getUrlApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202209_liveshopping_url", {
      params: {},
    });
  };

  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  _go = (item) => {
    const { history, loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
      //history.push('/login')
      history.push("/login");
    } else {
      isMobile
        ? window.open("https://mshop.aniplustv.com/item/" + item, "", "")
        : window.open("https://shop.aniplustv.com/item/" + item, "", "");
    }
  };
  render() {
    const { videoUrl, chatUrl, mHeight } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>애니플러스 라이브 커머스</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220902">
            <section className="section">
              <img
                src="/img/event/event220902/backimg_1.png"
                alt="라이브 커머스"
                className="img_web"
              />
              <img
                src="/img/event/event220902/m_backimg_1.png"
                alt="라이브 커머스"
                className="img_m"
              />
            </section>

            <section className="section">
              <div className="mov_wrap">
                <div className="mov">
                  {videoUrl === "" ||
                  videoUrl === null ||
                  videoUrl === undefined ? (
                    <>
                      <button className="btn_play">Play</button>
                      <div className="bg"></div>
                    </>
                  ) : (
                    <ReactPlayer
                      url={videoUrl}
                      playing
                      controls
                      width={"100%"}
                      height={"100%"}
                      //width={isMobile ? 320 : 640}
                    />
                  )}
                </div>
                <div className="chat">
                  {videoUrl === "" ||
                  videoUrl === null ||
                  videoUrl === undefined ? null : (
                    <iframe
                      src={`https://www.youtube.com/live_chat?v=${chatUrl}&embed_domain=www.aniplustv.com`}
                      width={"100%"}
                      height={isMobile ? mHeight : "100%"}
                    ></iframe>
                  )}

                  {/*
                                    <img src="/img/event/event220902/backimg_chat_sample.png" alt="ON AIR" className="img_web"/>
                                    <img src="/img/event/event220902/m_backimg_chat_sample.png" alt="ON AIR" className="img_m"/>
                                    */}
                </div>
              </div>
              {videoUrl === "" ||
              videoUrl === null ||
              videoUrl === undefined ? null : (
                <>
                  <img
                    src="/img/event/event220902/backimg_mov.png"
                    alt="ON AIR"
                    className="img_web"
                  />
                  <img
                    src="/img/event/event220902/m_backimg_mov.png"
                    alt="ON AIR"
                    className="img_m"
                  />
                </>
              )}
            </section>

            <section className="section pkg1">
              <a
                onClick={() => this._go(8456)}
                className="link"
                style={{ cursor: "pointer" }}
              >
                <span>구매하기</span>
              </a>
              <img
                src="/img/event/event220902/backimg_2-1.png"
                alt="칼리오페의 패키지 SET"
                className="img_web"
              />
              <img
                src="/img/event/event220902/m_backimg_2-1.png"
                alt="칼리오페의 패키지 SET"
                className="img_m"
              />
            </section>
            <section className="section pkg2">
              <a
                onClick={() => this._go(8457)}
                className="link"
                style={{ cursor: "pointer" }}
              >
                <span>구매하기</span>
              </a>
              <img
                src="/img/event/event220902/backimg_2-2.png"
                alt="키아라의 패키지 SET"
                className="img_web"
              />
              <img
                src="/img/event/event220902/m_backimg_2-2.png"
                alt="키아라의 패키지 SET"
                className="img_m"
              />
            </section>
            <section className="section pkg3">
              <a
                onClick={() => this._go(8458)}
                className="link"
                style={{ cursor: "pointer" }}
              >
                <span>구매하기</span>
              </a>
              <img
                src="/img/event/event220902/backimg_2-3.png"
                alt="이나니스의 패키지 SET"
                className="img_web"
              />
              <img
                src="/img/event/event220902/m_backimg_2-3.png"
                alt="이나니스의 패키지 SET"
                className="img_m"
              />
            </section>
            <section className="section pkg4">
              <a
                onClick={() => this._go(8459)}
                className="link"
                style={{ cursor: "pointer" }}
              >
                <span>구매하기</span>
              </a>
              <img
                src="/img/event/event220902/backimg_2-4.png"
                alt="구라의 패키지 SET"
                className="img_web"
              />
              <img
                src="/img/event/event220902/m_backimg_2-4.png"
                alt="구라의 패키지 SET"
                className="img_m"
              />
            </section>
            <section className="section pkg5">
              <a
                onClick={() => this._go(8460)}
                className="link"
                style={{ cursor: "pointer" }}
              >
                <span>구매하기</span>
              </a>
              <img
                src="/img/event/event220902/backimg_2-5.png"
                alt="아멜리아의 패키지 SET"
                className="img_web"
              />
              <img
                src="/img/event/event220902/m_backimg_2-5.png"
                alt="아멜리아의 패키지 SET"
                className="img_m"
              />
            </section>
            <section className="section">
              <img
                src="/img/event/event220902/backimg_3.png"
                alt="커머스 구매혜택"
                className="img_web"
              />
              <img
                src="/img/event/event220902/m_backimg_3.png"
                alt="커머스 구매혜택"
                className="img_m"
              />
            </section>
            <section className="section">
              <img
                src="/img/event/event220902/backimg_4.png"
                alt="커머스 구매인증 이벤트"
                className="img_web"
              />
              <img
                src="/img/event/event220902/m_backimg_4.png"
                alt="커머스 구매인증 이벤트"
                className="img_m"
              />
            </section>
          </div>

          {/*
                    <div style={{ float: 'left'}}>
                    <ReactPlayer
                        url={videoUrl} playing controls 
                        width={isMobile ? 320 : 640}
                    />
                    </div>
                    {gubun === 'LIVE' ? (
                        <div>
                            <iframe src="https://www.youtube.com/live_chat?v=FJfwehhzIhw&embed_domain=son.aniplustv.com" width="400" height="500"></iframe>
                        </div>
                    ) : null }
                    */}
        </div>

        {/*
                <div style={{ paddingTop: 20}}>
                    <span style={{ color: '#fff', fontSize: 16, cursor: 'pointer'}} onClick={this._go}>상품구매하기</span>
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202209_liveShopping));
